<script setup>
import { computed, onMounted, ref } from 'vue';
import { useAuthStore } from "@/app/stores/authStore";
import { useRouter } from 'vue-router';


// Services
import HolidayService from "@/api/services/holiday.service";

const authStore = useAuthStore();
const router = useRouter();

// Computed
const user = computed(() => authStore.getUserLogged);


const festivities = ref([])

onMounted(() => {
    getFestivities();
})

const getFestivities = () => {
    HolidayService.getNextPublicHolidays(user.value.id).then((res) => {
        const seen = new Set();
        const unique = (res.data.publicHolidays ?? []).filter((h) => {
            const key = `${h.date}|${h.name}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
        festivities.value = unique.slice(0, 6);
    })
}

const goToCalendar = () => {
    router.push('/calendar');
}

const formatDate = (dateString) => {
    if (!dateString) return '';
    let day, month;

    if (dateString.includes('-')) {
        const parts = dateString.split('-');
        if (parts[0].length === 4) {
            [, month, day] = parts;
        } else {
            [day, month] = parts;
        }
    } else {
        return dateString.toUpperCase();
    }

    const monthNames = [
        'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
        'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
    ];

    const monthIndex = parseInt(month, 10) - 1;
    const monthName = monthNames[monthIndex] || '';

    return `${parseInt(day, 10)} DE ${monthName}`;
}

</script>

<template>
    <div>
        <el-card class="box-card" body-style="padding:10px; background-color: #f7d20d">
            <div class="f-flex align-items-center justify-content-start full-card mb-2">
                <div class="card-icon d-flex justify-content-start align-items-center header col-12 mb-2">
                    <img class="festivity-icon" src="@/assets/icons/star-ubication-blue.svg" alt="star-icon" width="47"
                        height="47">
                    <span class="card-title">Festividades</span>
                </div>
                <div v-if="festivities.length > 0" class="birthday">
                    <div v-for="(birthday, index) in festivities" :key="birthday.id" class="birthday-item">
                        <div class="birthday-info text-birthday">
                            {{ formatDate(birthday.date) }} -- {{ birthday.name }}
                        </div>

                        <el-divider v-if="index < festivities.length - 1" class="divider" />
                    </div>
                </div>
                <div v-else>
                    No hay festividades
                </div>
                <div class="col-12 d-flex justify-content-end align-items-center">
                    <button class="btn btn_darkblue align-self-end justify-content-end btn-plus-birthdays"
                        @click="goToCalendar">+</button>
                </div>
            </div>
        </el-card>
    </div>
</template>

<style lang="scss" scoped>
.box-card {
    border-radius: 12px;
    color: #474ce6;
    margin-bottom: 15px;
}

.full-card {
    margin-left: 15px;
}

.header {
    min-width: 220px;
    width: 20%;
    height: 100%;

    span {
        letter-spacing: -0.05em;
        font-size: 1.3em;
        font-weight: bolder;
    }

    .card-title {
        margin: 0 10px;
        font-weight: 800;
        letter-spacing: -0.05em;
        font-size: 40px;
    }
}

.text-birthday {
    font-size: 16px;
    font-weight: 500;
}

.person-item {
    margin-bottom: 8px;
}

.divider {
    border-color: #474ce6;
    margin: 6px 0;
}

.btn-plus-birthdays {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    padding: 0;
}

@media (max-height: 790px),
(max-width: 860px) {
    .header {
        .card-title {
            font-size: 30px;
        }
    }
}
</style>
